import { Table } from "antd";
import { formatRupee } from "../../../../utils";


interface QuartileBucketProps {
  data: any[];
  loading: boolean;
}

const QuartileBucket = ({ data, loading }: QuartileBucketProps) => {  
  const QUARTILE_LABEL_MAP: Record<string, string> = {
  Q1: "Q1 (0–25%)",
  Q2: "Q2 (25%–50%)",
  Q3: "Q3 (50%–75%)",
  Q4: "Q4 (75%–100%)",
};

 const preQuartileTableColumn = [
   {
    title: "Quartile",
    dataIndex: "bucketName",
    key: "bucketName",
    render: (value: string) => QUARTILE_LABEL_MAP[value] || value,
  },
  { title: "Original Principal", dataIndex: "originalPrincipal", key: "originalPrincipal" , render: (originalPrincipal:any) => <span>{formatRupee(originalPrincipal) || "-"}</span>,},
  { title: "Outstanding Value", dataIndex: "osValue", key: "osValue",render: (osValue:any) => <span>{formatRupee(osValue) || "-"}</span>,} ,
  { title: "Total Borrowers", dataIndex: "totalBorrowers", key: "totalBorrowers" },
  { title: "Min O/S", dataIndex: "min", key: "min",render: (min:any) => <span>{formatRupee(min) || "-"}</span> },
  { title: "Max O/S", dataIndex: "max", key: "max",render: (max:any) => <span>{formatRupee(max) || "-"}</span> },
  { title: "Average O/S", dataIndex: "average", key: "average",render: (average:any) => <span>{formatRupee(average) || "-"}</span> },
  { title: "Median O/S", dataIndex: "median", key: "median" ,render: (median:any) => <span>{formatRupee(median) || "-"}</span> },
];


  return (
    <div className="mt-10">
      <Table
        loading={loading}
        columns={preQuartileTableColumn}
        dataSource={data}
        size="middle"
        pagination={false}
        style={{ cursor: "pointer" }}
        rowKey="bucketName"
      />
      <div className="mt-4 text-sm text-gray-600">
        <strong>Abbreviations:</strong>
        <ul className="list-disc flex justify-between ml-6 mt-1">
          <li><strong>Min O/S</strong> – Minimum Outstanding</li>
          <li><strong>Max O/S</strong> – Maximum Outstanding</li>
          <li><strong>Average O/S</strong> – Average Outstanding</li>
          <li><strong>Median O/S</strong> – Median Outstanding</li>
        </ul>
      </div>
    </div>
  );
};

export default QuartileBucket;
